import React from "react";

import { Cards } from "./Cards";

export const App = () => {
  return (
    <div className="container">
      <header>
        <h2 className="underline">Our Tours</h2>
      </header>

      <Cards />
    </div>
  );
};
